/**
 * @desc purchaseStockOccupy
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.PurchaseStockOccupyRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/purchaseStock/occupy`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
